/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EonAccountStatus } from '../models/EonAccountStatus';
import { User } from '../models/User';

export class EonAccount {
  /**
  * The ID of the account
  */
  'id': string;
  /**
  * The name of the account
  */
  'name': string;
  /**
  * The domain of the account
  */
  'domain': string;
  'status': EonAccountStatus;
  /**
  * The user pool ID
  */
  'userPoolId': string;
  /**
  * The user pool client ID
  */
  'cognitoClientId': string;
  /**
  * The AWS Marketplace subscription ID
  */
  'awsSubscriptionId'?: string;
  /**
  * The Azure Marketplace subscription ID
  */
  'azureSubscriptionId'?: string;
  /**
  * The GCP Marketplace subscription ID
  */
  'gcpSubscriptionId'?: string;
  'users'?: Array<User>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "domain",
      "baseName": "domain",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "EonAccountStatus",
      "format": ""
    },
    {
      "name": "userPoolId",
      "baseName": "userPoolId",
      "type": "string",
      "format": ""
    },
    {
      "name": "cognitoClientId",
      "baseName": "cognitoClientId",
      "type": "string",
      "format": ""
    },
    {
      "name": "awsSubscriptionId",
      "baseName": "awsSubscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "azureSubscriptionId",
      "baseName": "azureSubscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "gcpSubscriptionId",
      "baseName": "gcpSubscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "users",
      "baseName": "users",
      "type": "Array<User>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EonAccount.attributeTypeMap;
  }

  public constructor() {
  }
}



